import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPopsicle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPopsicle1"><Path d="M5.5 4.5C5.5 2.84315 6.84315 1.5 8.5 1.5H15.5C17.1569 1.5 18.5 2.84315 18.5 4.5V17.5H5.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10.25 17.5H13.75V20.75C13.75 21.7165 12.9665 22.5 12 22.5C11.0335 22.5 10.25 21.7165 10.25 20.75V17.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 6.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 6.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPopsicle1;
